import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Typography, IconButton, MenuItem, Select } from '@mui/material';
import { X } from 'lucide-react';
import AppButton from '../../../common_components/AppButton';
const PublisherLimitModal = ({ open, onClose, onSubmit, loading }) => {
    const [limit, setLimit] = React.useState(10);
    return (_jsxs(Dialog, { open: open, onClose: onClose, maxWidth: "sm", fullWidth: true, sx: {
            "& .MuiPaper-root": {
                borderRadius: "8px",
                p: 1
            }
        }, children: [_jsxs(DialogTitle, { sx: { m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }, children: [_jsx(Typography, { variant: "h6", sx: { fontWeight: 600, color: '#181D27' }, children: "Publisher Limit" }), _jsx(IconButton, { onClick: onClose, size: "small", sx: { color: '#98A2B3' }, children: _jsx(X, { size: 20 }) })] }), _jsx(DialogContent, { sx: { py: 4 }, children: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 4 }, children: [_jsx(Typography, { sx: { color: '#344054', fontWeight: 500, minWidth: '180px' }, children: "Select Publishers Limit" }), _jsxs(Select, { value: limit, onChange: (e) => setLimit(e.target.value), fullWidth: true, size: "small", sx: {
                                borderRadius: '8px',
                                bgcolor: '#F9FAFB',
                                '& .MuiOutlinedInput-notchedOutline': { borderColor: '#D0D5DD' }
                            }, children: [_jsx(MenuItem, { value: 10, children: "10" }), _jsx(MenuItem, { value: 20, children: "20" }), _jsx(MenuItem, { value: 30, children: "30" }), _jsx(MenuItem, { value: "ALL", children: "ALL" })] })] }) }), _jsxs(DialogActions, { sx: { p: 2, gap: 1 }, children: [_jsx(AppButton, { onClick: onClose, variant: "outlined", sx: {
                            flex: 1,
                            color: '#344054',
                            borderColor: '#D0D5DD',
                            bgcolor: '#F9FAFB',
                            textTransform: 'none',
                            fontWeight: 600
                        }, children: "CANCEL" }), _jsx(AppButton, { onClick: () => onSubmit(limit), variant: "contained", loading: loading, sx: {
                            flex: 1,
                            bgcolor: '#000',
                            '&:hover': { bgcolor: '#1a1a1a' },
                            textTransform: 'none',
                            fontWeight: 600
                        }, children: "SUBMIT" })] })] }));
};
export default PublisherLimitModal;
